import classNames from 'classnames';
import { MaterialIcon } from 'shared/ui/MaterialIcon';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

export function PendingIcon({ className = '' }: { className?: string }) {
  return (
    <MaterialIcon
      {...getDataAutoTestAttributes(['icon-pending'])}
      className={classNames(`text-base text-orange-500 select-none`, className)}
    >
      update
    </MaterialIcon>
  );
}
